// eslint-disable-next-line max-classes-per-file
import { useMemo } from "react";
import { Quill } from "react-quill";
// eslint-disable-next-line import/no-extraneous-dependencies
import QuillMarkdown from "quilljs-markdown";

Quill.register("modules/QuillMarkdown", QuillMarkdown, true);

function createSimpleExpression(char: string, group?: string, lookback = "<="): RegExp {
    const charGroup = group ?? `(${char})`;
    return new RegExp(
        `(?${lookback}^|\\s)` // start or space
        + `(?:${charGroup}(?!\\s)([^${char}]+)(?<!\\s)${char})`
        + `(?:$|(?=\\s))`, // ends in space or end
        "",
    );
}

export default function useMarkdown() {
    return useMemo(() => ({
        QuillMarkdown: {
            ignoreTags: ["h1", "h2", "h3", "h4", "h5", "h6", "variable"],
            tags: {
                blockquote: {
                    pattern: /^(>){1}\s/g,
                },
                bold: {
                    pattern: createSimpleExpression("\\*", undefined, "<="),
                },
                italic: {
                    pattern: createSimpleExpression("_", undefined, ":"),
                },
                strikethrough: {
                    pattern: createSimpleExpression("~", "~", "<="),
                },
                codeblock: {

                },
            },

        },
    }), []);
}
